import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UsuarioBeneficioGerenciarCartoesService {

  constructor(private readonly http: HttpClient) { }

  getDadosSegundaViaCartao(idUsuario: any, idProduto: any) {
    return this.http.get(`/apiconnect/importation/occurrence/cards/${idUsuario}/users/${idProduto}/products`);
  }

  concluirSolicitacao(body: any) {
    return this.http.post(`/apiconnect/importation/occurrence/cards`, body);
  }

  getHistoricoOcorrenciasCartoes(idUsuario: any, idProduto: any) {
    return this.http.get(`/apiconnect/importation/occurrence/historic-cards/${idUsuario}/users/${idProduto}/products`);
  }
}
